mtl.alloy.factory.datepicker = (function($, app, util) {
	'use strict';

	$('.icon-calendar').on('click', function(){
		$(this).siblings('[data-init="datepicker"]').select();
	});

	/**
	 * Convert a date object to a 'yyyymmdd' string.
	 */
	function dateToString(date) {

		return '' +
			('0000' + date.getFullYear()).substr(-4) +
			('00' + (date.getMonth() + 1)).substr(-2) +
			('00' + date.getDate()).substr(-2)
		;

	}


	/**
	 * Convert a 'yyyymmdd' string to a date object.
	 */
	function stringToDate(string) {

		return new Date(
			string.substr(0, 4) | 0,
			(string.substr(4, 2) | 0) - 1,
			string.substr(6, 2) | 0
		);

	}


	/**
	 * Test whether a day exists in a valid-days hash.
	 */
	function isValidDay(date, validDaysHash) {

		return !!validDaysHash[dateToString(date)];

	}


	/**
	 * jQuery UI datepicker.
	 */
	return function(element, options) {

		var $element = $(element);

		var validDaysArray = options.validDays || $element.data('validDays');
		var validDaysHash = null;

		if (validDaysArray) {
			validDaysHash = {};
			for (var i in validDaysArray) {
				validDaysHash['' + validDaysArray[i]] = true;
			}
		}

		var minDate = null;
		var maxDate = null;

		if (validDaysArray) {
			minDate = stringToDate('' + validDaysArray[0]);
			maxDate = stringToDate('' + validDaysArray[validDaysArray.length - 1]);
		}

		var changeMonth, changeYear = false;

		if($element.attr('data-changeMonth') == 'true')
			changeMonth = true;

		if($element.attr('data-changeYear') == 'true')
			changeYear = true;

		var defaultDate = null;

		if($element.attr('data-defaultDate') != '')
			defaultDate = $element.attr('data-defaultDate');

		var yearRange = null;

		if($element.attr('data-yearRange') != '')
			yearRange = $element.attr('data-yearRange');

		$(element).datepicker({

			minDate: minDate,
			maxDate: maxDate,

			changeMonth: changeMonth,
			changeYear: changeYear,

			defaultDate: defaultDate,

			yearRange: yearRange,

			beforeShowDay: function(date) {

				var dayEnabled = true;
				var dayClass = '';

				if (validDaysHash) {
					dayEnabled = dayEnabled && isValidDay(date, validDaysHash);
				}

				return [
					dayEnabled,
					dayClass,
				];

			}

		});

	};

}(jQuery));
